const states = {
    tabs: [], // 所选tab集合
};
export default states;


// WEBPACK FOOTER //
// ./src/store/modules/team/states/index.js